import { useState, useLayoutEffect } from 'react';

var hydrated = false;
var markHydrated = function markHydrated() {
  hydrated = true;
};
var useBrowser = function useBrowser() {
  // Ensure we start with true if we are hydrated
  var _useState = useState(hydrated),
      browser = _useState[0],
      setBrowser = _useState[1];
  /* eslint-disable react-hooks/exhaustive-deps */
  // We ONLY run this on the client, and only once


  useLayoutEffect(function () {
    if (!browser) {
      setBrowser(true);
    }
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  return browser;
};

export { markHydrated, useBrowser };
//# sourceMappingURL=browser.esm.js.map
